<geaui-page-layout-v3 [headerTemplate]="header" [contentTemplate]="content" [sidebarTemplate]="sidebar">
  <ng-template #header>
    @if (noAuth !== undefined) {
      <geaui-header
        [noAuth]="noAuth"
        [showLangDropdown]="!noAuth"
        [showBanner]="false"
        [disableSignupMobile]="true"
        [disableLoginMobile]="true"
        [headerTitle]="headerTitle">
      </geaui-header>
    }
  </ng-template>
  <ng-template #content>
    <!--
    Loading Spinner will be shown in three cases:
    Case 1: Auth Page and Token & User are not ready
    Case 2: No Auth Page and User is logged in, but Token & User are not ready yet
    Case 3: No Auth Page and User is not logged in,
    Case 4: No Auth Page and User is logged out

    Case 2, 3 & 4 deal with views that can be accessed without authentication (noAuth).
    For those views the user either could be logged in (Case 2) or logged out (Case 3/4)
    for the logged in user we display the spinner until the token % user are ready.
    For the logged out user we wait until MSAL confirms that the user is logged out.
    -->
    @if (!((!noAuth && tokenReady && userReady) || (noAuth && tokenReady && userReady) || (noAuth && loggedOutPageReady))) {
      <div class="spinner">
        <geaui-progress-spinner [size]="'large'"></geaui-progress-spinner>
      </div>
    }

    <div class="content-body">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
  <ng-template #sidebar>
    @if (tokenReady) {
      <geaui-sidebar-v3
        [navigationItems]="navItems"
        [adminViewNavigationItems]="isAdminViewActive() ? adminNavItems : []"
        [bottomNavigation]="botItems"
        [devisionName]="headerTitle"
        [devisionIconPath]="divisionIconUrl"
        devisionIconBackgroundColor="#197aef">
      </geaui-sidebar-v3>
    }
  </ng-template>
</geaui-page-layout-v3>
